var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.headerRows.length > 0
        ? _c("app-sidebar-key-value-list", { attrs: { rows: _vm.headerRows } })
        : _vm._e(),
      !_vm.loaded && _vm.rows.length == 0
        ? _c(
            "div",
            { staticClass: "sidebar-loading" },
            [_c("w-progress-circular", { attrs: { small: "" } })],
            1
          )
        : _vm.rows.length == 0
        ? _c("div", { staticClass: "sidebar-empty" }, [
            _vm._v(_vm._s(_vm.$ct("sidebar.sale-rows.none"))),
          ])
        : _c(
            "div",
            { staticClass: "sidebar-table-wrap" },
            [
              _c(
                "app-custom-table",
                {
                  staticClass: "sidebar-table",
                  attrs: { cellpadding: "0", cellspacing: "0" },
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$ct("sidebar.sale-rows.product"))),
                      ]),
                      _c("th", { staticClass: "amount small" }, [
                        _vm._v(_vm._s(_vm.$ct("sidebar.sale-rows.amount"))),
                      ]),
                      _c("th", { staticClass: "amount" }, [
                        _vm._v(_vm._s(_vm.$ct("sidebar.sale-rows.total"))),
                      ]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.rows, function (row, i) {
                      return _c("tr", { key: i }, [
                        _c("td", [
                          _c("div", { staticClass: "sidebar-row-sku" }, [
                            _vm._v(_vm._s(row.ProductSku)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "sidebar-row-description" },
                            [_vm._v(_vm._s(_vm.description(row)))]
                          ),
                        ]),
                        _c("td", { staticClass: "amount small" }, [
                          _vm._v(_vm._s(_vm.printAmount(row.Amount))),
                        ]),
                        _c("td", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.printFloat(row.TotalPriceExcVat))),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
      _c("app-sidebar-key-value-list", { attrs: { rows: _vm.totalRows } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }